import React from 'react';
import { ReportFinalizeActions } from '@/pages/reports/new/components';

interface ReportEditActionsProps {
  isSaving: boolean;
  onFinalizeClose: () => void;
  onFinalizeSend: () => void;
  onDelete: () => void;
  errorMessage?: string;
}

export const ReportEditActions: React.FC<ReportEditActionsProps> = ({
  isSaving,
  onFinalizeClose,
  onFinalizeSend,
  onDelete,
  errorMessage = '',
}) => (
  <ReportFinalizeActions
    isSaving={isSaving}
    onFinalizeClose={onFinalizeClose}
    onFinalizeSend={onFinalizeSend}
    onDelete={onDelete}
    errorMessage={errorMessage}
  />
);
